<template>
    <v-container
        class="m-0"
        style="padding: 16px;"
    >
        <v-col v-if="!$vuetify.breakpoint.xs">
            <v-data-table
                id="main_revisions_table"
                ref="main_revisions_table"
                fixed-header
                :headers="headers"
                :items="getRevisions"
                item-key="id"
                hide-default-footer                          
            >
                <template v-slot:item.viewDetails="tid">
                    <v-icon
                        class="mr-2"
                        @click="viewRevisionDetails(tid)"
                    >
                        preview
                    </v-icon>
                </template>
            </v-data-table>
        </v-col>

        <v-col
            v-if="$vuetify.breakpoint.xs"
            id="ticket-revisions-cards"
        >
            <v-card
                v-for="item in getRevisions"
                :key="item.id"
                flat
                tile
                @click="viewRevisionDetails(item.tid)"
            >
                <table class="px-3 py-4">
                    <tr>
                        <td>Revisions:</td>
                        <td>{{ item.revision }}</td>
                    </tr>
                    <tr>
                        <td>Member:</td>
                        <td>{{ item.member_code }}</td>
                    </tr>
                    <tr>
                        <td>Locator:</td>
                        <td>{{ item.date_located }}</td>
                    </tr>
                    <tr>
                        <td>Responses:</td>
                        <td>{{ item.response_code }}</td>
                    </tr>
                    <tr>
                        <td>Status:</td>
                        <td>{{ item.status }}</td>
                    </tr>
                </table>
                <v-icon class="material-icons-outlined">
                    chevron_right
                </v-icon>
            </v-card>
        </v-col>
    </v-container>
</template>

<script>

export default {
    name: 'RevisionsList',
    data: () => ({
        TRStage: { 'IR': 'Un-Assigned', 'AL': 'Assigned', 'CT': 'Closed'},
        headers: [
            {
                text: 'Revisions',
                value: 'revision',
                align: 'left',
                width: '80px',
                sortable: false,
            },
            {
                text: 'Member',
                value: 'member_code',
                align: 'left',
                width: '80px',
                sortable: false,
            },
            {
                text: 'Locator',
                value: 'date_located',
                align: 'left',
                width: '80px',
                sortable: false,
            },
            {
                text: 'Responses',
                value: 'response_code',
                align: 'left',
                width: '80px',
                sortable: false,
            },
            {
                text: 'Status',
                value: 'status',
                align: 'left',
                width: '80px',
                sortable: false,
            },
            {
                text: 'View Details',
                value: 'viewDetails',
                align: 'center',
                width: '80px',
                sortable: false,
            },
        ],
    }),
    computed: {
        getTicketDetails() {
            return this.$store.getters.ticketDetails;
        },
        getRevisions() {
            if(this.$store.getters.ticketDetails) {
                let revesion = this.$store.getters.ticketDetails.revisions.map((item, index) => {
                    item.id=index;
                    item.status = this.TRStage[item.TR_stage];
                    return item;
                });
                return revesion;
            } else {
                return [];
            }
        }
    },
    methods: {
        viewRevisionDetails(item) {
            if(item.item) {
                this.$router.push({ path: `/tickets/details/revisionsdetails?tid=${item?.item?.tid}` });
            } else {
                this.$router.push({ path: `/tickets/details/revisionsdetails?tid=${item}` });
            }
        }
    }
};
</script>

<style>
    #main_revisions_table.v-data-table {
        border: 1px solid #ccc;
        width: 100%;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
        overflow: hidden;
    }
    #main_revisions_table.v-data-table__wrapper {
        border-radius: 4px;
    }
    #main_revisions_table .v-data-table-header th{
        background: #F5F7FA !important;
    }

    #ticket-revisions-cards {
        padding: 0px 12px;
    }
    #ticket-revisions-cards .v-card {
        border-bottom: 1px solid #d3d5d8;
    }
    #ticket-revisions-cards .v-card {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
    }
    #ticket-revisions-cards .ticket-card-info {
        border-radius: 4px;
        border: 1px solid #E4E7ED;
        height: 28px;
        display: inline-block;
        min-width: 40px;
        margin-top: 16px;
        margin-bottom: 16px;
        margin-right: 8px;
        padding: 4px 8px;
        color: #35383F;
        font-size: 12px;
    }
    #ticket-revisions-cards table {
        font-size: 12px;
        width: 100%;
    }
    #ticket-revisions-cards table tr td:first-child {
        width: 82px;
    }
    #ticket-revisions-cards table tr td:nth-child(2) {
        font-weight: 500;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: 0;
    }
    #ticket-revisions-cards .status-open-chip {
        margin-right: 10px;
    }
</style>